import React, { useState, useEffect } from 'react';
import Icon from 'components/AppIcon';
import { supabase } from 'lib/supabase';


const ExecutiveMetrics = ({ selectedPeriod }) => {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMetrics();
  }, [selectedPeriod]);

  const fetchMetrics = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        ?.from('system_metrics')
        ?.select('*')
        ?.order('metric_date', { ascending: false })
        ?.limit(1)
        ?.single();

      if (error) throw error;
      setMetrics(data);
    } catch (error) {
      console.error('Error fetching metrics:', error?.message);
    } finally {
      setLoading(false);
    }
  };

  const keyMetrics = [
    {
      id: 1,
      title: "Total Active Users",
      value: metrics?.active_users || 0,
      total: metrics?.total_users || 0,
      change: `+${metrics?.new_users || 0} this ${selectedPeriod?.slice(0, -2)}`,
      changeType: "positive",
      icon: "Users",
      color: "bg-primary-50 text-primary"
    },
    {
      id: 2,
      title: "Pending Verifications",
      value: metrics?.pending_verifications || 0,
      change: "Lawyer KYC pending",
      changeType: "warning",
      icon: "ShieldAlert",
      color: "bg-warning-50 text-warning-600"
    },
    {
      id: 3,
      title: "System Uptime",
      value: `${metrics?.system_uptime_percentage || 100}%`,
      change: "Last 30 days",
      changeType: "positive",
      icon: "Activity",
      color: "bg-success-50 text-success-600"
    },
    {
      id: 4,
      title: "Platform Usage",
      value: metrics?.active_cases || 0,
      total: metrics?.total_cases || 0,
      change: `${metrics?.completed_cases || 0} completed`,
      changeType: "neutral",
      icon: "TrendingUp",
      color: "bg-secondary-50 text-secondary-600"
    }
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[1, 2, 3, 4]?.map((i) => (
          <div key={i} className="bg-surface rounded-lg shadow-card p-6 border border-border animate-pulse">
            <div className="h-12 bg-secondary-100 rounded mb-4"></div>
            <div className="h-8 bg-secondary-100 rounded mb-2"></div>
            <div className="h-4 bg-secondary-100 rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {keyMetrics?.map((metric) => (
        <div key={metric?.id} className="bg-surface rounded-lg shadow-card p-6 border border-border hover:shadow-lg transition-smooth">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${metric?.color}`}>
              <Icon name={metric?.icon} size={24} />
            </div>
            <Icon name="MoreHorizontal" size={16} className="text-text-secondary cursor-pointer" />
          </div>
          <div>
            <h3 className="text-2xl font-heading font-bold text-text-primary mb-1">
              {metric?.value}
              {metric?.total && (
                <span className="text-sm text-text-secondary font-normal ml-2">/ {metric?.total}</span>
              )}
            </h3>
            <p className="text-sm text-text-secondary mb-2">{metric?.title}</p>
            <p className={`text-xs font-medium ${
              metric?.changeType === 'positive' ? 'text-success' :
              metric?.changeType === 'warning' ? 'text-warning-600' : 'text-text-secondary'
            }`}>
              {metric?.change}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExecutiveMetrics;